const aaa = [
	
    {
		path: "livingbody",
		component: () => import("@/views/chanpin/livingbody/livingbody.vue"),
		meta:{title:'活体',keepAlive:true},
	},
]
export default aaa;